import axios from "axios"
import * as $ from "jquery";

export default class Spinner {
    public static spinner(object = null): void {
        if(!object) {
            object = '#api-input';
        }
        $(object).html(
            '<div class="spinner-container"><div class="spinner"></div></div>'
        );
    }

    public static smallSpinner(object, bool): void {
        if (bool) {
            $(object).html(
                '<div class="spinner-small-container"><div class="spinner-small"></div></div>'
            );
        } else {
            $(object).html('');
        }
    }

    public static plannerSpinner(object, bool): void {
        if (bool) {
            $(object).html(
                '<div class="spinner-planner-container"><div class="spinner-small"></div></div>'
            );
        } else {
            $(object).html('');
        }
    }
}import axios from "axios"
import * as $ from "jquery";

export default class Spinner {
    public static spinner(object = null): void {
        if(!object) {
            object = '#api-input';
        }
        $(object).html(
            '<div class="spinner-container"><div class="spinner"></div></div>'
        );
    }

    public static smallSpinner(object, bool): void {
        if (bool) {
            $(object).html(
                '<div class="spinner-small-container"><div class="spinner-small"></div></div>'
            );
        } else {
            $(object).html('');
        }
    }

    public static plannerSpinner(object, bool): void {
        if (bool) {
            $(object).html(
                '<div class="spinner-planner-container"><div class="spinner-small"></div></div>'
            );
        } else {
            $(object).html('');
        }
    }
}